import React, { memo, useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { useIntl } from 'react-intl'
// import FilterListIcon from '@mui/icons-material/FilterList'
// import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import { useSelector } from 'react-redux'
import { formatTypesName } from 'utils/miscellaneous'
// import isEmpty from 'lodash/isEmpty'
// import pickBy from 'lodash/pickBy'
import SearchRounded from '@mui/icons-material/SearchRounded'
import sx from './styles'

const CurrentFilter = ({ handleClickModal }) => {
  const { formatMessage: f } = useIntl()
  const { filters } = useSelector((s) => s.search)
  const [text, setText] = useState(
    f({ id: 'SEARCH_SEE_ALL_VEHICLES_BY' }, { body: formatTypesName(filters?.body) || 'los autos' }),
  )

  useEffect(() => {
    setText(f({ id: 'SEARCH_SEE_ALL_VEHICLES_BY' }, { body: formatTypesName(filters?.body) || 'los autos' }))
  }, [filters?.body])

  return (
    <Button
      sx={sx.btnContainer}
      disableElevation
      onClick={handleClickModal}
      aria-label={text}
      // startIcon={<FilterListIcon color="secondary" />}
      id="btn-abrir-filtros-srp"
    >
      <SearchRounded
        color="primary"
        sx={sx.searchIcon}
      />

      {/* <Text type={TEXT_TYPES.button.text}>
        {text}
      </Text>
      {!isEmpty(pickBy({ ...filters, body: null })) && (
        <Box sx={sx.chip}>
          <Text
            type={TEXT_TYPES.quote}
          >
            {Object.keys(pickBy({ ...filters, body: null })).length}
          </Text>
        </Box>
      )} */}
    </Button>
  )
}

export default memo(CurrentFilter)
